<template>
    <div class="db" >
        <div class="b-search">
            <!-- 下拉选择框  输入框  按钮 放在一排  组件使用ele-->
            <div class="banner-search">
                <el-select class="el-select" v-model="value">
                    <el-option v-for="item in options" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
                <el-input class="el-input" placeholder="请输入内容" v-model="input" clearable
                    @keyup.enter.native="onsubmit()"></el-input>
                <el-button class="el-button" @click="sousuo()" type="primary"> <img src="../assets/pic-search-white.png"
                        alt=""> </el-button>
            </div>
            <!-- 检索包括繁体勾选 -->
            <div class="fjyselect">
                <el-checkbox style="margin-top: 10px;margin-right: 10px;" v-model="checked">检索包含：简体、繁体、异体</el-checkbox>
            </div>
            <!-- 表格div -->
            <div class="dbentry-table">
                <!-- 顶部切换选择  -->
                <div class="dbentry-table-1">

                    <div class="dbentry-table-tm" :class="swentries == 1 ? 'dbentry-table-bk' : ''" @click="swentrie"
                        style="cursor: pointer;">条目</div>
                    <div class="dbentry-table-qw" :class="swentries == 2 ? 'dbentry-table-bk' : ''" @click="swftext"
                        style="cursor: pointer;">全文</div>
                    <div class="jilu">共有<span style="color: brown;">{{ dataSize }}</span>条记录</div>

                </div>
                <!-- 第二层选择器条目 -->
                <div class="dbentry-table-tiaomu">
                    <div v-show="swentries != 2" class="sjkxz">
                        <!-- 循环出选择的 -->
                        <span class="sjkxz-btn " :class="dbsleid == 0 ? 'xuan' : ''" @click="dbsle(0)">全部</span>
                        <span class="sjkxz-btn " :class="dbsleid == 1 ? 'xuan' : ''" @click="dbsle(1)">中华大典</span>
                        <span class="sjkxz-btn " :class="dbsleid == 2 ? 'xuan' : ''" @click="dbsle(2)">徽州文书</span>
                        <span class="sjkxz-btn " :class="dbsleid == 3 ? 'xuan' : ''" @click="dbsle(3)">冷战时期档案数据库</span>
                        <span class="sjkxz-btn " :class="dbsleid == 4 ? 'xuan' : ''" @click="dbsle(4)">汉语基督教文献书目数据库</span>
                        <span class="sjkxz-btn " :class="dbsleid == 5 ? 'xuan' : ''" @click="dbsle(5)">东方智慧丛书</span>
                        <span class="sjkxz-btn " :class="dbsleid == 6 ? 'xuan' : ''" @click="dbsle(6)">古籍文献书目</span>
                        <span class="sjkxz-btn " :class="dbsleid == 7 ? 'xuan' : ''" @click="dbsle(7)">学术辑刊</span>
                    </div>
                    <div class="ihead tabletop">
                        <span class="ttop-1">书名</span>
                        <span class="ttop-2">作者</span>
                        <span class="ttop-3">摘录</span>
                        <span class="ttop-4">出处</span>
                    </div>

                    <div class="itiaomu tabletop ibk setRed" v-for="(dbitem, index) in gatherlist" :key="index"
                        @click="goto(dbitem.id,dbitem.type)">
                        <span class="ttop-a" v-html="dbitem.title">{{ dbitem.title }}</span>
                        <span class="ttop-b" v-html="dbitem.author">{{ dbitem.author }}</span>
                        <div class="ttop-c" v-html="dbitem.except">{{dbitem.except}}</div>
                        <span class="ttop-d">{{ dbitem.dataysource }}</span>
                    </div>

                </div>
            </div>
        
      <div class="page">
        <el-pagination
          :background="true"
          layout="prev, pager, next"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          :page-size="10"
          :total="dataSize"
        >
        </el-pagination>
      </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
.db {
    background-color: #f0f0f0;
}

.page {
  width: 1200px;
  margin: 0 auto;
  padding: 50px;
  text-align: right;
  .active  {
    background-color: #7b112c !important;
  }
}
//搜索输入框选择器
.b-search {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
}

//banner-search flex布局 从左到右 水平居中 垂直居中
.banner-search {
    width: 1000px;
    height: 60px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 32px;

    .el-select {
        ::v-deep .el-input__inner {
            height: 60px;
        }
    }

    .el-input {
        width: 800px;
        height: 60px;
        color: #000;

        ::v-deep .el-input__inner {
            height: 60px;

        }
    }

    .el-button {
        width: 77px;
        height: 60px;
        background-color: #921333;
        color: #fff
    }
}

//繁体勾选菜单。
.fjyselect {
    width: 1000px;
    margin: 0 auto;
    display: flex;
    flex-direction: row-reverse;
}

//表格切换
.dbentry-table {
    width: 80%;
    min-width: 1241px;
    margin: 15px auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .dbentry-table-1 {
        display: flex;
        justify-content: row;
        align-items: center;
        height: 51px;
        width: 80%;
        min-width: 1241px;

        .dbentry-table-tm {
            width: 140px;
            height: 51px;

            text-align: center;
            line-height: 51px;
            size: 20px;
        }

        .dbentry-table-bk {
            background-color: #fff;
        }

        .dbentry-table-qw {
            width: 140px;
            height: 51px;
            text-align: center;
            line-height: 51px;
            size: 20px;
        }

        .jilu {
            margin-left: 800px;
        }


    }

    .dbentry-table-tiaomu {
        width: 80%;
        min-width: 1241px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        background-color: #fff;

        .sjkxznone {
            display: none;

        }

        .sjkxz {
            display: flex;
            justify-content: row;
            align-items: center;
            height: 51px;
            width: 100%;

            .sjkxz-btn {
                height: 32px;
                padding: 0 16px;
                text-align: center;
                line-height: 32px;
                margin-left: 30px;
                border-radius: 16px;
                cursor: pointer;
                border: 1px solid #cccccc;
                font-size: 14px !important;
                color: #333333;
            }

            .xuan {
                background-color: #921535;
                color: #fff;
            }
        }

        .tabletop {
            display: flex;
            justify-content: row;
            align-items: center;
            height: 51px;
            width: 100%;

            .ttop-1 {
                width: 20%;
            }

            .ttop-2 {
                width: 15%;
            }

            .ttop-3 {
                width: 45%;
            }

            .ttop-4 {
                width: 20%;
            }

            .ttop-a {
                width: 20%;
                text-align: left;
            }

            .ttop-b {
                width: 15%;
            }

            .ttop-c {
                width: 45%;
                height: 67%;
                padding-left: 5px;
                text-align: left;
                line-height: 28px;
                overflow: hidden;
                text-overflow: ellipsis;
            }


            .ttop-d {
                width: 20%;
            }
        }

        .ihead {
            width: 98%;
            font-size: 16px;
            background-color: #f3e7e8;
            color: #780b27;
            margin: 1% 1% 0 1%;
        }

        .itiaomu {
            width: 98%;
            margin: 1% 1% 0 1%;
            font-size: 16px;
            cursor: pointer;
        }

        .ibk {
            border-bottom: 1px dashed #eeeeee;
            height: 88px;
        }

    }

}
</style>
<script>
import { Loading } from 'element-ui';
import $ from 'jquery';
function setTextRed(searchText) {
    if(searchText != ""){
        clearSelection();
        var regExp = new RegExp(searchText, 'g');
        $('.setRed').each(function() {
            var html = $(this).html();
            var newHtml = html.replace(regExp, '<b class="search-text-color">' + searchText + '</b>');
            $(this).html(newHtml);
        })
    }
};
function clearSelection(){
    $('.setRed').each(function() {
        $(this).find('.search-text-color').each(function() {
            $(this).replaceWith($(this).html());
        });
    })
};

export default {
    name: "app",
    methods: {
        goto(itemid,type){
            console.log("跳转",itemid,type)
            if(this.swentries == 1){
                switch(type){
                case "1":
                //    window.location.href = 'http://zhdd.qiushifang.com/details.aspx?id=' + itemid
                   window.open( 'http://zhdd.qiushifang.com/details.aspx?id=' + itemid);
                    break;
                case "2":
                window.open('http://hzws.qiushifang.com/View.aspx?id=' + itemid)
                //    window.location.href = 'http://hzws.qiushifang.com/View.aspx?id=' + itemid
                    break;
                case "6":
                let routeData = this.$router.resolve({ path: "/view/bookdetails" ,query: {id:itemid,typekey: 3}});
                window.open(routeData.href);
                    break; 
                default:
                this.$message('暂未开放查看');
                    break;
            }
         }else if(this.swentries == 2){
            this.$router.push({ path: "/view/bookdetails" ,query: {id:itemid,typekey: 3}});
       
         }

        },
        //切换条目
        swentrie() {
            this.currentPage = 1;
            this.swentries = 1;
     
            this.searchlistdb(this.dbsleid, this.input, 1);
            console.log("切换条目")
        },
        //切换全文
        swftext() {
            this.currentPage = 1;
            this.swentries = 2;
      
            this.searchquanwen(this.input, 1);
            console.log("切换全文")
        },
        dbsle(id) {
            this.dbsleid = id;
            this.searchlistdb(this.dbsleid, this.input, 1);
            console.log("选择数据库", id);
        },
        //翻页
        handleCurrentChange(page) {
            console.log('测试', page);
            this.currentPage = page;
            this.isActive = true;
            let ddown = this.value;  //下拉选择的值
            var ipt = this.input;
            if (this.swentries == 1) {
           
                console.log('测试dd1', page);
                this.searchlistdb(this.dbsleid, ipt, this.currentPage);
            } else if (this.swentries == 2) {
              
                console.log('测试dd2', page);
                this.searchquanwen(this.input, this.currentPage);
            }
        },
        //点击搜索
        sousuo(msg) {
            this.currentPage = 1;
            this.isActive = true;
            let ddown = this.value;  //下拉选择的值
            var ipt = this.input;
            if (ddown == 1) {
                this.swentries = 1;
                this.searchlistdb(this.dbsleid, ipt, 1);
            } else if (ddown == 2) {
                this.swentries = 2;
                this.searchquanwen(this.input, 1);
            }
        },
        //回车键
        onsubmit(msg) {
            this.currentPage = 1;
            this.isActive = true;
            let ddown = this.value;  //下拉选择的值
            var ipt = this.input;
            if (ddown == 1) {
                this.swentries = 1;
                this.searchlistdb(this.dbsleid, ipt, 1);
            } else if (ddown == 2) {
                this.swentries = 2;
                this.searchquanwen(this.input, 1);
            }
        },
        //搜索数据库条目
        searchlistdb(id, title, page) {
            this.gatherlist = [];
            let options = { fullscreen: true }
            let loadingInstance = Loading.service(options);
            setTimeout(() => {
                loadingInstance.close();
            }, 2000);
            Loading.service(options);
            console.log(`${global.BASE_URL}/api/getDblist?id=${id}&title=${title}&page=${page}`)
            this.$http.get(`${global.BASE_URL}/api/getDblist?id=${id}&title=${title}&page=${page}`).then((res) => {
                console.log("-------",res.data)
                const json = res.data;
                const obj = JSON.parse(json);
                this.gatherlist = obj.dbdata
                // console.log("结果" + obj.number)
                this.dataSize = obj.number
                loadingInstance.close();
                return obj.number
            });
            setTimeout(() => {
                setTextRed(title);
            }, 2000);
           
        },
        //搜索数据库全文
        searchquanwen(title, page) {
            let options = { fullscreen: true }
            let loadingInstance = Loading.service(options);
            setTimeout(() => {
                loadingInstance.close();
            }, 2000);
            Loading.service(options);
            this.$http.get(`${global.BASE_URL}/api/getDblist?id=6&title=${title}&page=${page}`).then((res) => {
                // console.log("-------",res.data)
                const json = res.data;
                const obj = JSON.parse(json);
                this.gatherlist = obj.dbdata
                // console.log("结果" + obj.number)
                this.dataSize = obj.number
                loadingInstance.close();
                return obj.number
            });
            setTextRed(title);
        }

    },
    created() {
        this.swentries = this.$route.query.ddown;
        //判断是否为空、
        if (this.swentries == null || this.swentries == "") {
            this.swentries = 1;
        }else{
            this.value = this.swentries;
        }
        this.input = this.$route.query.input;

        if (this.swentries == 1) {
            console.log("1拉")
            this.searchlistdb(0, this.input, 1);
        } else if (this.swentries == 2) {

            this.searchquanwen(this.input, 1);
            console.log("2拉")
        }

    },
    //更新列表

    data() {
        return {
            activeIndex: "1",
            input: "",
            isActive: false,
            currentPage: 1,
            gatherlist: [],
            dataSize: 0,
            swentries: 1,
            dbsleid: 0,
            checked: false,
            page: 1,
            value: "1",
            options: [
                { value: "1", label: "条目" },
                { value: "2", label: "全文" },
            ],
        };
    },
};

</script>


